import { redirect } from '../../utils/url';

/**
 * @param {String} url
 * @param {String} appName
 * @param {String} hash
 * @returns {String}
 */
function getExperimentalUrl(url, appName, hash) {
  return url.replace(`static/${appName}`, `static/global/exp/${appName}/${hash}`);
}

/**
 * Redirect to an experimental URL if the experiment is in the
 * localStorage
 * @param {Object} app
 * @param {Object} app.props
 * @returns {Promise}
 */
export default function setup({ props }) {
  const hash = __lift.experiments.getExperimentHash(props.name);

  if (hash) {
    redirect(getExperimentalUrl(props.href, props.name, hash));
    return Promise.reject();
  }
  return Promise.resolve(true);
}
